import React, { useEffect, useState } from 'react';

import { InputField, CheckBoxesField, MultiSelectField } from 'basics';

import FileUploader from 'components/FileUploader';

import { mergeRoles } from 'model/options';

import useFirestore from 'hooks/useFirestore';

export default function AwardForm({ register, setValue, errors, item, setPending }) {
	const [awardRoles, setAwardRoles] = useState([]);
	const [criteriaItems, setCriteriaItems] = useState([]);
	const {getItems} =  useFirestore();

	useEffect(() => {

		setAwardRoles(mergeRoles(item && item.roles));

		getItems({collection: 'criteria'}).then((result) => {
			setCriteriaItems(result.map((item) => {
				return {value: item.id, label: item.title}
			}));
		})

	}, [getItems, item]);

	return (
		<>
			<InputField
				label="Título"
				type="text"
				value={item && item.title}
				id="title"
				register={register}
				errors={errors}
				mode="dark"
				required={true}
			/>
			<InputField
				label="Descripción"
				type="text"
				value={item && item.description}
				id="description"
				register={register}
				errors={errors}
				mode="dark"
				required={true}
			/>

			<CheckBoxesField
				options={awardRoles}
				register={register}
				error={errors.roles}
				id="roles"
				label="Roles Asociados"
				mode="dark"
				twoLines={true}
				required={true}
			/>

			{/* Mismo control que los premios a evaluar del form de usuarios: el
			    `select multiple` nativo obligaba a scrollear a ciegas y a usar
			    ctrl+click para sumar, y un click suelto borraba la selección. */}
			<MultiSelectField
				options={criteriaItems}
				id="criteria"
				label="Criterios"
				value={item && item.criteria}
				required={true}
				register={register}
				error={errors.criteria}
				mode="dark"
				columns={2}
				emptyMessage="No hay criterios activos para asignar"
			/>

			<FileUploader
				label="PDF"
				id="pdf"
				value={item && item.pdf}
				folder={`awards`}
				register={register}
				error={errors.pdf}
				setValue={setValue}
				accepted="application/pdf"
				mode="dark"
				required={true}
				onPendingChange={setPending}
			/>
		</>
	)
}